import { pillSwitchStyle } from '/b2b/common/components/ValidationForm/components/ValidationField/components/ValidationSwitch/ValidationSwitch.styles';

export default theme => ({
    // Card surface matching the redesigned notification cards
    // (GroupedValidationForm): 24px padding, bold title, muted one-line
    // description, and a divider before the channel rows. This card is a sibling
    // rendered above <NotificationForm>, so it sits outside the grouped form's
    // inter-card `gap` — add a matching bottom margin so it doesn't touch the
    // first group card (Cookie Consent).
    card: {
        borderRadius: 10,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
    },
    cardTitle: {
        fontWeight: 600,
    },
    cardDescription: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    cardDivider: {
        margin: theme.spacing(2, 0),
    },
    rows: {
        display: 'flex',
        flexDirection: 'column',
    },
    // One row per channel: label + helper text on the left, controls (Connect
    // button, toggle, saving spinner) on the right. Rows are separated by a
    // hairline divider; the first/last rows drop their outer padding so the
    // content hugs the surrounding divider evenly.
    channelRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: theme.spacing(2, 0),
        '&:first-child': {
            paddingTop: 0,
        },
        '&:last-child': {
            paddingBottom: 0,
        },
        '&:not(:last-child)': {
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
    },
    channelText: {
        flex: '1 1 auto',
        minWidth: 0,
    },
    channelLabel: {
        fontWeight: 600,
    },
    helperText: {
        marginTop: theme.spacing(0.5),
        color: theme.palette.text.secondary,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexShrink: 0,
    },
    // 38×22 pill switch shared with the restyled ValidationSwitch (PLATFORM-1586)
    // so the delivery card's bare <Switch> rows match the grouped form's toggles.
    switch: pillSwitchStyle(theme),
});
